<template>
  <base-modal
      v-if="visible"
      hide-header-close
      hide-footer
      :title="title"
      @close="$emit('close')"
    >
        <coordinate-editor
          v-if="coordinate"
          v-model="coordinate"
          size="sm"
          :point-type="OTHER"
          :show-weather-stations="showWeatherStations"
          @close="$emit('close')"
          @set-location="saveLocation"
        />
  </base-modal>
</template>

<script>
import CoordinateEditor from "./CoordinateEditor";
import {mapHelper} from "./mixins/MapMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: "CoordinateEditorModal",
    components: {BaseModal, CoordinateEditor},
    mixins: [mapHelper],
    props: {
        visible: {
            type: Boolean
        },
       modelValue: {
            type: Object
        },
        pointType: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showWeatherStations: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            coordinate: null
        }
    },
    watch: {
        coordinate: function() {
            if (this.coordinate !== this.modelValue) {
                this.$emit('update:modelValue', this.coordinate)
                this.$nextTick(() => this.$emit('close'))
            }
        }
    },
    mounted() {
        this.coordinate = this.modelValue
    },
    methods: {
        saveLocation() {
            this.$emit('setLocation')
        }
    }
}
</script>
